import { styled } from 'parkdepot-shared/theme'

export const AddVehicleWrapper = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.white,
    paddingTop: '2rem',
    marginBottom: '1.6rem',
    borderTop: '1px solid #EAECF0'
}))

export const NoVehiclesWrapper = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.white,
    borderRadius: '24px',
    padding: '2rem',
    textAlign: 'center',
    border: '1px solid #B3BBC7',
    marginBottom: '2rem'
}))

export const FullWrapper = styled('div', ({ $theme }) => ({
    height: '100%',
    minHeight: '65vh',
    padding: '0 2rem'
}))

export const Title = styled('h3', ({ $theme }) => ({
    ...$theme.typography.HeadingXSmall,
    fontWeight: 700,
    margin: '2rem 0 4rem 0',
    textAlign: 'center'
}))

export const Subtitle = styled('h4', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    fontWeight: 700,
    margin: '4rem 0 2rem'
}))

export const NoVehicleIcon = styled('i', ({ $theme }) => ({
    fontSize: '3.2rem'
}))

export const NoVehicleText = styled('h3', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    fontWeight: 700,
    margin: '0.8rem 0'
}))

export const NoVehicleDescription = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0
}))

export const VehicleAddIcon = styled('i', ({ $theme }) => ({
    fontSize: '1.6rem',
    marginRight: '12px'
}))

export const NewVehicleButtonOverride = {
    BaseButton: {
        style: {
            width: '100%'
        }
    }
}

export const LoadingContainer = styled('div', ({ $theme }) => ({
    marginTop: '20%',
    height: '100%'
}))
